module.exports = __webpack_public_path__ + "static/media/16_portrait.0326dd27.jpg";